import { useContext } from 'react';

import { ApplicationContext } from '@App/contexts/Application';
import BookCallView from '@Views/shared/BookCallView';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';

const BookCallCalendarPage = () => {
    const { loading } = useContext(ApplicationContext);

    const successNavLink =
        '/eligibility/loan-preferences/book-call/confirmation';

    return (
        <EligibilityLayout loading={loading} showTrustbarV2>
            <BookCallView successNavLink={successNavLink} />
        </EligibilityLayout>
    );
};

export default BookCallCalendarPage;
